// search.js — buscador predictivo nativo estilo Nike (autónomo, sin dependencias del bundle)
(function () {
  'use strict';
  var modal = document.getElementById('searchModal');
  if (!modal) return;

  var el = {
    input: document.getElementById('searchInput'),
    form: document.getElementById('searchForm'),
    clear: document.getElementById('searchClear'),
    close: document.getElementById('closeSearchModal'),
    results: document.getElementById('searchResults'),
    collections: document.getElementById('collectionSuggestions'),
    collectionsWrap: document.getElementById('collectionSuggestionsWrap'),
    recentWrap: document.getElementById('recentSearches'),
    recentList: document.getElementById('recentSearchesList'),
    popularWrap: document.getElementById('popularSearches'),
    popularList: document.getElementById('popularSearchesList'),
    noResults: document.getElementById('searchNoResults'),
    footer: document.getElementById('modalFooter'),
    viewAll: document.getElementById('viewAllResults')
  };

  var POPULAR = ['Guantes', 'Guayos', 'Balón', 'Medias', 'Aletas', 'Natación'];
  var RECENT_KEY = 'regol_recent_searches';
  var reqToken = 0;
  var debounceTimer = null;

  // ---------- utilidades ----------
  function money(v) {
    var n = Math.round(parseFloat(v || '0'));
    return '$ ' + n.toLocaleString('es-CO');
  }
  function esc(s) { return (s || '').replace(/"/g, '&quot;'); }

  function getRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { return []; }
  }
  function saveRecent(q) {
    q = (q || '').trim(); if (!q) return;
    var list = getRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    list.unshift(q);
    list = list.slice(0, 6);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {}
  }

  // ---------- abrir / cerrar ----------
  function openModal() {
    modal.classList.add('open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    setTimeout(function () { el.input && el.input.focus(); }, 50);
    renderEmptyState();

    // Prevent legacy search card from overlaying
    var cardFilters = document.querySelector('.search-card');
    if (cardFilters) cardFilters.classList.remove('open');
  }
  function closeModal() {
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');

    // Clean up legacy header state classes to prevent bugged header layout
    var headerFilters = document.querySelector('.header__filters');
    if (headerFilters) headerFilters.classList.remove('isOpen');
    var header = document.querySelector('.header');
    if (header) header.classList.remove('open');
    var cardFilters = document.querySelector('.search-card');
    if (cardFilters) cardFilters.classList.remove('open');
  }
  window.RegolSearch = { open: openModal, close: closeModal };

  el.close && el.close.addEventListener('click', closeModal);
  modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('open')) closeModal();
  });

  // Desconectar el buscador viejo del bundle: clonar el input del header quita sus listeners
  var headerInput = document.querySelector('.header__filters--input');
  if (headerInput) {
    var fresh = headerInput.cloneNode(true);
    headerInput.parentNode.replaceChild(fresh, headerInput);
    fresh.addEventListener('focus', openModal);
    fresh.addEventListener('click', openModal);
    var headerForm = fresh.closest('form');
    if (headerForm) {
      headerForm.addEventListener('submit', function (e) { e.preventDefault(); openModal(); });
      // En móvil la lupa colapsada es el propio formulario: un solo toque abre el modal
      headerForm.addEventListener('click', openModal);
    }
  }

  // ---------- fetch ----------
  function suggestUrl(q) {
    var params = new URLSearchParams();
    params.set('q', q);
    params.set('resources[type]', 'product,collection');
    params.set('resources[limit]', '8');
    params.set('resources[options][unavailable_products]', 'last');
    params.set('resources[options][fields]', 'title,product_type,variants.sku,vendor');
    return '/search/suggest.json?' + params.toString();
  }
  function doSearch(q) {
    var token = ++reqToken;
    fetch(suggestUrl(q), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (token !== reqToken) return;
        var res = (data.resources && data.resources.results) || {};
        renderResults(res.products || [], res.collections || [], q);
      })
      .catch(function () { if (token === reqToken) renderError(); });
  }

  // ---------- render ----------
  function toggleEmptySections(showEmpty) {
    if (el.popularWrap) el.popularWrap.hidden = !showEmpty;
    if (el.recentWrap) el.recentWrap.hidden = !(showEmpty && getRecent().length);
    if (el.collectionsWrap) el.collectionsWrap.hidden = showEmpty;
    if (el.footer) el.footer.hidden = showEmpty;
  }

  // Corregido: chipsHtml generaba nike-search__chip en el script original del backup.
  function chipsHtml(items) {
    return items.map(function (t) {
      return '<li><button type="button" class="nike-search__chip" data-q="' + esc(t) + '">' + t + '</button></li>';
    }).join('');
  }

  function renderEmptyState() {
    if (el.results) el.results.innerHTML = '<div class="nike-search__hint">Escribe para buscar productos por nombre, marca o referencia.</div>';
    if (el.noResults) el.noResults.hidden = true;
    if (el.collections) el.collections.innerHTML = '';
    if (el.popularList) el.popularList.innerHTML = chipsHtml(POPULAR);
    if (el.recentList) el.recentList.innerHTML = chipsHtml(getRecent());
    toggleEmptySections(true);
  }

  function renderResults(products, collections, q) {
    toggleEmptySections(false);
    // Colecciones (izquierda)
    if (el.collections) {
      el.collections.innerHTML = collections.map(function (c) {
        return '<li><a class="nike-search__collection" href="' + c.url + '">' + (c.title || '') + '</a></li>';
      }).join('');
    }
    if (el.collectionsWrap) el.collectionsWrap.hidden = collections.length === 0;
    // Productos (derecha)
    if (el.viewAll) el.viewAll.href = '/search?q=' + encodeURIComponent(q);
    if (!products.length) {
      if (el.results) el.results.innerHTML = '';
      if (el.noResults) {
        el.noResults.hidden = false;
        var msg = el.noResults.querySelector('.nike-search__no-results-text');
        if (msg) msg.textContent = 'No encontramos productos para «' + q + '». Prueba con otro término.';
      }
      if (el.footer) el.footer.hidden = false;
      return;
    }
    if (el.noResults) el.noResults.hidden = true;
    if (el.footer) el.footer.hidden = false;
    if (el.results) {
      el.results.innerHTML = products.map(function (p) {
        var img = p.image ? '<img src="' + p.image + '" alt="' + esc(p.title) + '" loading="lazy">' : '';
        var onSale = parseFloat(p.compare_at_price_min || '0') > parseFloat(p.price || '0');
        var priceHtml = onSale
          ? '<span class="nike-search__price"><span class="nike-search__price--compare">' + money(p.compare_at_price_min) + '</span> ' + money(p.price) + '</span>'
          : '<span class="nike-search__price">' + money(p.price) + '</span>';
        return '<a class="nike-search__card" href="' + p.url + '">' +
          '<span class="nike-search__card-img">' + img + '</span>' +
          '<span class="nike-search__card-title">' + (p.title || '') + '</span>' +
          (p.vendor ? '<span class="nike-search__card-brand">' + p.vendor + '</span>' : '') +
          priceHtml +
        '</a>';
      }).join('');
    }
  }

  // Corregido error en renderError
  function renderError() {
    if (el.results) el.results.innerHTML = '<p class="nike-search__error">No se pudo cargar la búsqueda. Intenta de nuevo.</p>';
  }

  // ---------- input ----------
  el.input && el.input.addEventListener('input', function () {
    var q = el.input.value.trim();
    if (el.clear) el.clear.hidden = q.length === 0;
    clearTimeout(debounceTimer);
    if (q.length < 2) { renderEmptyState(); return; }
    debounceTimer = setTimeout(function () { doSearch(q); }, 250);
  });

  el.clear && el.clear.addEventListener('click', function () {
    el.input.value = '';
    el.clear.hidden = true;
    el.input.focus();
    renderEmptyState();
  });

  el.form && el.form.addEventListener('submit', function (e) {
    e.preventDefault();
    var q = el.input.value.trim();
    if (!q) return;
    saveRecent(q);
    window.location.href = '/search?q=' + encodeURIComponent(q);
  });
  el.viewAll && el.viewAll.addEventListener('click', function () {
    var q = el.input.value.trim(); if (q) saveRecent(q);
  });

  // Delegación: click en chip rellena el input y busca
  modal.addEventListener('click', function (e) {
    var b = e.target.closest('.nike-search__chip');
    if (!b) return;
    var q = b.getAttribute('data-q') || '';
    el.input.value = q;
    if (el.clear) el.clear.hidden = q.length === 0;
    el.input.focus();
    if (q.length >= 2) doSearch(q);
  });
})();
